/*
 *  Bootstrap Nice Select Turkish (Turkey) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['tr-TR'] = localisation.locales['tr'] = {
    formatSearch() {
        return "Aranıyor...";
    },
    formatHelpForTagging() {
        return "Kendi etiketlerinizi oluşturmak için giriş alanına odaklanın ve ardından listeye eklemek için 'Enter' veya ',' veya 'Boşluk Çubuğu'na basın";
    }
}

export default localisation;